// Popover.tsx
import React, { useEffect } from 'react';
import { useFloating, offset, flip, shift } from '@floating-ui/react-dom';
import { Backdrop } from './Backdrop';

interface PopoverProps {
    referenceElement: HTMLElement | null;
    children: React.ReactNode;
    onClose: () => void;
    showBackdrop?: boolean;
    backdropZIndex?: number;
    popoverZIndex?: number;
    // ... otras props que ya ten�as
}

export const Popover = ({
    referenceElement,
    children,
    onClose,
    showBackdrop = true,
    backdropZIndex = 100,
    popoverZIndex = 101,
    ...props
}: PopoverProps) => {
  const { x, y, refs, floatingStyles, update } = useFloating({
    middleware: [offset(7), flip(), shift()],
    placement: 'bottom-end',
  });

  // Establece el elemento de referencia manualmente
  React.useEffect(() => {
    if (referenceElement) {
      refs.setReference(referenceElement);
      update();
    }
  }, [referenceElement, refs, update]);

  // Cierre al hacer clic fuera
  React.useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        refs.floating.current &&
        !refs.floating.current.contains(e.target as Node)
      ) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [refs, onClose]);

  return (
      <>
          {showBackdrop && (
              <Backdrop
                  show={!!referenceElement}
                  onClick={onClose}
                  zIndex={backdropZIndex}
              />
          )}
      {referenceElement && (<div
      ref={refs.setFloating}
      style={{
        ...floatingStyles,
        top:'2px',
        left:'17px',
        background: 'white',
        border: '1px solid #ccc',
        borderRadius: '6px',
        padding: '8px 12px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          zIndex: popoverZIndex,
        minWidth: '200px',
      }}
    >
      {children}
          </div>)}
      </>
  );
};
